<template >
	<v-dialog v-model="show_dialog" max-width="500px" persistent>
      <v-card>
        <v-card-title primary-title class="headline info lighten-2">
          {{dlg_config.title}}
        </v-card-title>
        <v-card-text>
          <v-form v-model="valid" class="mb-4" ref="form">
      		  <myinput v-for="field in dlg_config.fields" 
      		  		v-model="field.value"
      		  		:key="field.name" 
      		  		:field="field"
                :err_msg="field.err_msg"
                :rules= "field.rules?field.rules:[]"
      		  		@change='(val)=>{field_change(val,field.name)}'>
      		  	</myinput>
            </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="btn-danger" @click.stop="show_dialog=doing=false,action('cancel')">取消</v-btn>
          <v-btn class="btn-success" 
          	:loading="doing"
  	      	:disabled="doing" 
  	      	@click.stop="action('ok')">确定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>   
</template>

<script>
import myinput from "../components/form_item"
export default {
    //template:``,
    name: '',
    props:{
    	width:{type:String,default:"500px"},
    },
    computed:{
    	show_dialog:{
	      get(){
	          return this.$store.state.dialog.show_user_input_dialog;
	      },
	      set(val){
	          this.$store.commit('SHOW_DIALOG_USER_INPUT',val)
	      }
	    },
	    dlg_config(){
	    	return  this.$store.state.dialog.user_input_fields;
	    }
    },
    methods:{
    	close_dialog(){
        this.doing       = false;
        this.show_dialog = false;
    	},
      set_errmsg(fd,err){
        if(!err) return;
        let field = this.dlg_config.fields.find(it=> it.name == fd);
        if(field){
            field.err_msg.splice(0,field.err_msg.length);
            field.err_msg.push(err);
        }
      },
    	field_change(value,fd){
    		console.log("field_change:",fd,value);
    		console.log("value:",this.dlg_config);
    		if(this.dlg_config.change)
    			this.dlg_config.change(value,fd)
    	},
    	action(type){
        let data = {}
        this.dlg_config.fields.map(fd=>{
            data[fd.name] =  fd.value;
        })
    		this.dlg_config.action&&this.dlg_config.action({
    				close : this.close_dialog,
    				self  : this,
            data,
    				type  : type?type:'cancel'
    		})
    	},
    },
    components:{myinput},
    watch:{},
    directives: {},
    mounted :function(){},
    data () {
      return {
          valid   :false,
          doing   :false,
          err_msg :[]
      }
    },
    filters: {
      //pluralize: (n, w) => n === 1 ? w : (w + 's'),
      capitalize: s => s.charAt(0).toUpperCase() + s.slice(1)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/front_sale/dialogs/dialog_user_input.vue